import React from "react";
import { Navigate } from "react-router-dom";
import permissionsService from "../../services/permissionsService";

interface PermissionGuardProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
}

export default function PermissionGuard({
  children,
  requiredPermissions = [],
}: PermissionGuardProps) {
  const { hasPermission } = permissionsService();

  const permissionsPass =
    requiredPermissions.length === 0 ||
    requiredPermissions.some((perm) => hasPermission(perm));

  if (!permissionsPass) {
    return <Navigate replace to="/403" />;
  }

  return <>{children}</>;
}
